<mat-dialog-title class="dialog-header dialog-header-nomargin"
  [ngClass]="[
    titleTheme == 'default' ? 'dialog-header-dark ' : '',
    titleTheme == 'blue' ? 'dialog-header-active' : '',
    titleTheme == 'red' ? 'dialog-header-error': ''
  ]">
  <span class="title-span" fxFlex="auto"> {{title}} </span>
  <button type="button" title="close-dialog" class="dialog-close-btn" tabindex="-1" mat-icon-button mat-dialog-close (click)="onClose()">
    <mat-icon>close</mat-icon>
  </button>
</mat-dialog-title>